import storage from "@/utils/storage";
import router from "@/router";

const state = {
    userInfo: storage.get("userInfo"),
    token: storage.get("token"),
    tabActive: '/home',
};
const mutations = {
    setUserInfo(state, data) {
        storage.set("token", data.token || "");
        storage.set("userInfo", data);
        state.userInfo = data;
        state.token = data.token;
    },
    setOutLogin(state) {
        storage.remove("token");
        storage.remove("userInfo");
        state.userInfo = "";
        state.token = "";
        router.push('/home')
    },
    setTabActive(state, data) {
        state.tabActive = data
    },
    setNavigateTo(state, data){

        if (window.__wxjs_environment === 'miniprogram') {
            /* eslint-disable */
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    wx.miniProgram.navigateTo({url: '/pages/login/login?type=1'})
                }
            })
        } else {
            router.push('/login')
        }

    }
};
const getters = {

    userInfoGetter: (state) => state.userInfo,
    tokenGetter: (state) => state.token,
    tabActiveGetter: (state) => state.tabActive,

};
const actions = {};

export default {
    name: "user",
    state,
    mutations,
    getters,
    actions,
};
